import { uniqueId } from 'lodash';
import React, { useState } from 'react';
import { Checkbox, Label } from './Form';

const CheckboxReveal = ({ label, children, onToggle, initialIsVisible = false }) => {
  const [visible, setVisible] = useState(initialIsVisible);
  const id = uniqueId();

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          name={id}
          id={id}
          value={visible}
          onChange={e => {
            setVisible(e.target.value);

            if (onToggle) {
              onToggle(e.target.value);
            }
          }}
          style={{ marginRight: '0.5em', marginBottom: '0' }}
        />

        <Label isInline htmlFor={id} style={{ marginBottom: '0px' }}>
          {label}
        </Label>
      </div>

      {typeof children === 'function' && children({ visible })}

      {typeof children !== 'function' && visible && <div className="ml-[26px]">{children}</div>}
    </>
  );
};

export default CheckboxReveal;
